<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-page-header @back="goBack" content="多通道配置"></el-page-header>
    </el-breadcrumb>

    <el-card class="box-card" style="margin-top:20px">
      <el-row>
        <label>{{addForm.merchant_name}}</label>
        <el-button type="primary" size="mini" @click="openPaySource">新增通道</el-button>
      </el-row>
      <el-tabs v-model="activeName" @tab-click="openPay1()">

        <el-tab-pane label="三方通道" name="first">
          <div style="width: 100%; display: flex;flex-direction: row;justify-content: flex-start;flex-wrap: wrap;">

            <el-card class="pay_box-card" v-for="(item,index) in merchantPaySourceParamsList" :key="index">

              <div slot="header" class="clearfix">
              <span>
                <el-badge :value="item.sn == addForm.pay_sn?'启用':''" class="item">
                  <label style="padding: 10px 20px;">{{item.name}}</label>
                 </el-badge>
              </span>
                <el-button style="float: right; padding: 3px 0" type="text" @click="goSet(item)">编辑</el-button>
              </div>
              <div  class="text item" style="display: flex;justify-content: space-between;">
                <span v-if="item.cusid!=null" style="color:#ff0000;font-size: 14px;"> 已配置</span>
                <span v-if="item.cusid==null" > 未配置</span>

                <span  style="color:#17c717">启用</span>
              </div>

            </el-card>

          </div>
        </el-tab-pane>

        <!--        <el-tab-pane label="直连通道" name="second">-->
        <!--          <el-card class="box-card">-->
        <!--            <div slot="header" class="clearfix">-->
        <!--              <span>卡片名称</span>-->
        <!--              <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>-->
        <!--            </div>-->
        <!--            <div v-for="o in 4" :key="o" class="text item">-->
        <!--              {{'列表内容 ' + o }}-->
        <!--            </div>-->
        <!--          </el-card>-->
        <!--        </el-tab-pane>-->
      </el-tabs>

      <!--      通联参数配置-->
      <el-dialog title="参数配置" :visible.sync="dialogTlSet" width="850px">
        <el-form :model="setForm" label-width="80px">
          <el-form-item label="商户号">
            <el-input v-model="setForm.cusid"  type="textarea" autocomplete="off" placeholder="请输入机构号"></el-input>
          </el-form-item>
          <el-form-item label="MD5密钥" v-if="setForm.sn=='P012'">
            <el-input v-model="setForm.md5_secret"  type="textarea" autocomplete="off" placeholder="请输入MD5密钥"></el-input>
          </el-form-item>
          <el-form-item label="APPID" v-if="setForm.sn!='P012'">
            <el-input v-model="setForm.appid"  type="textarea" autocomplete="off" placeholder="请输入appid"></el-input>
          </el-form-item>
          <el-form-item label="公钥" v-if="setForm.sn!='P012'">
            <el-input v-model="setForm.public_key"  type="textarea" autocomplete="off" placeholder="请输入公钥"></el-input>
          </el-form-item>
          <el-form-item label="私钥" v-if="setForm.sn!='P012'">
            <el-input v-model="setForm.private_key"  type="textarea" autocomplete="off" placeholder="请输入私钥"></el-input>
          </el-form-item>
          <el-form-item label="终端号" v-if="setForm.sn!='P012'">
            <el-input v-model="setForm.num"  type="textarea" autocomplete="off" placeholder="请输入终端号"></el-input>
          </el-form-item>
          <!--          <el-form-item label="GMV费率(%)" >-->
          <!--            <el-input v-model="setForm.sn"  type="textarea" autocomplete="off" placeholder="请输入GMV费率"></el-input>-->
          <!--          </el-form-item>-->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancelSet">取 消</el-button>
          <el-button size="mini"  type="primary" @click="submitSet('setForm')">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 切换弹出通道 -->
      <el-dialog title="切换通道" :visible.sync="dialogPaySource" width="550px">
        <div style="color: #ff0000">(只可启用已审核/已配置的通道,切换通道后商户类型将无法改回)</div>
        <el-radio-group v-model="pay_sn">
          <el-table
            ref="singleTable"
            :data="paySourceList"
            highlight-current-row

            style="width: 100%">
            <el-table-column
              type="index"
              label="单行"
              width="50">
            </el-table-column>
            <el-table-column
              property="date"
              label="支付通道"
              width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="通道类型"
              width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.type_id==2?'直连':'三方' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              width="180"
              label="当前启动通道">
              <template slot-scope="scope">
                <el-radio :label="scope.row.sn"></el-radio>
              </template>
            </el-table-column>
          </el-table>
        </el-radio-group>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancelPay">取 消</el-button>
          <el-button size="mini" type="primary" @click="submitPay()">确 定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>

  import axios from 'axios'
  import moment from 'moment'     //日期时间转换
  export default {
    name:"merchantPayMoreList",
    components: {  },
    data() {
      return {
        pay_sn:'',
        setForm:{
          sn:'',
          cusid:'',
          public_key:'',
          private_key:'',
          pay_source_id:'',
          md5_secret:'',
          num:''
        },
        merchantPaySourceParamsList:[],
        paySourceList:[],
        dialogPaySource:false,
        dialogTlSet:false,
        index:0,
        activeName:'first',
        list:[{
          project_name:'',
          constract_amount:'',
          approval_amount: null,
          approved_amount: '',
          deduction_amount:'',
          increase_amount:'',
          rate:'',
          isEgdit: true,

        }],
        gradeList:[],
        baseUrl:'/api/',
        fileList:[],
        shopList:[],
        dicList:[],
        provinceList:[],
        addForm:{
          pay_sn:'',
          merchant_name:'',
          psparams:[],
          artiperson:'',
          basic_name:"",
          work_status:'',
          status:'',
          name:'',
          contract_sn:'',
          contract_start_time:'',
          contract_end_time:'',
          grade_id:'',
          id:'',
          province_id:"",
          city_id:"",
          district_id:"",
          sex:'',
          amount:'',
          id_code:'',
          mobile:'',
          remark:'',
          order_time:'',
          summary:"",
          manager_name:'',
          unit_name:"",
          telephone:'',
          address:'',
          cont_name:'',
          shop_id:'',
          description:'',
          shop_img:'',
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
        },
        ruleForm:{
          url:'',
          start_time:"",
          ad_id:'',
          ad_name:'',
          ad_link:'',
          position_id:'',
          ad_code:''
        },
        cateMenus:[],
        editor: null,
        html: '<p>hello</p>',
        toolbarConfig: { },
        editorConfig: { placeholder: '请输入内容...',
          // 所有的菜单配置，都要在 MENU_CONF 属性下
          MENU_CONF: {
            //配置上传图片
            uploadImage: {
              customUpload: this.uploadImg
            }
          }
        },
        mode: 'default', // or 'simple'
        rules: {
          name:[
            { required: true, message: "请输入公司名称", trigger: 'change' }
          ],
          provinc_id:[
            { required: true, message: "请选择省市", trigger: 'change' }
          ],

        },
        areaList:[],
        isResouceone: false,
        propsdata: {
          // 懒加载地区列表
          lazy: true,
          lazyLoad(node, resolve) {
            // const { level } = node;
            console.log(node)
            let url= '/api/api/cmp.sys.Region_read_lz/findRegionList';
            setTimeout(() => {
              // 第一級
              if (node.level == 0) {
                // Ajax請求數據，填充選擇框
                // 接口请求获取省份

                axios.post(url,{
                  access_token:sessionStorage.getItem('token'),
                  company_id:sessionStorage.getItem('company_id'),
                  parent_id:1
                }).then((res)=>{
                  if(res.data.code==200){
                    const nodes = res.data.data.map((item) => ({
                      value: item.id,
                      label: item.name,
                      //  leaf: node.children >= 1,
                    }));
                    resolve(nodes);
                  }
                });
              }
              // 第二級
              if (node.level == 1) {
                // Ajax請求數據，填充選擇框
                // 接口请求获取省份
                // var _this=this;
                axios.post(url,{
                  access_token:sessionStorage.getItem('token'),
                  company_id:sessionStorage.getItem('company_id'),
                  parent_id:node.value
                }).then((res)=>{
                  if(res.data.code==200){
                    const nodes = res.data.data.map((item) => ({
                      value: item.id,
                      label: item.name,
                      //  leaf: node.children >= 1,
                    }));
                    resolve(nodes);
                  }
                });
              }
              if (node.level == 2) {
                // Ajax請求數據，填充選擇框
                // // 接口请求获取省份
                axios.post(url,{
                  access_token:sessionStorage.getItem('token'),
                  company_id:sessionStorage.getItem('company_id'),
                  parent_id:node.value
                }).then((res)=>{
                  if(res.data.code==200){
                    const nodes = res.data.data.map((item) => ({
                      value: item.id,
                      label: item.name,
                      leaf: true,
                    }));
                    resolve(nodes);
                  }
                });
              }
            }, 100);
          },
        },
      }
    },
    mounted() {
      var id= this.$route.query.id;
      if(!isNaN(id)&&id>0){
        this.addForm.id=id;
        this.getOne();
        this.getPaySourceParamsList();
      }
      this.getPaySourceList();

    },
    methods: {
      cancelPay(){
        this.dialogPaySource=false;
      },
      submitPay(){
        let _this=this;

        this.$confirm('您确定要切换, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id:_this.addForm.member_id,
            pay_sn:_this.pay_sn
          }
          this.$axios.posMemberSetPaySource(param).then(res=>{
            if(res.code == 200){
              _this.getOne();
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
        this.dialogTlSet=false;
        this.dialogPaySource=false;
      },
      cancelSet(){
        this.setForm={};
        this.dialogTlSet=false;
      },
      submitSet(){
        let _this=this;
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          member_id:_this.addForm.member_id,
          pay_source_id:_this.setForm.pay_source_id,
          cusid:_this.setForm.cusid,
          appid:_this.setForm.appid,
          public_key:_this.setForm.public_key,
          private_key:_this.setForm.private_key,
          md5_secret: _this.setForm.md5_secret? _this.setForm.md5_secret:'',
          num:_this.setForm.num? _this.setForm.num:'',
        }
        console.log('eeeee----',param)
        this.$axios.paySourceSaveParams(param).then(res=>{
          if(res.code == 200){
            this.getPaySourceList();
          }
        }).catch(error=>{
          console.log(error);
        })
        this.dialogTlSet=false;
      },
      goSet(row){

        this.setForm=row;
        this.setForm.pay_source_id=row.id;
        console.log('this.setForm',this.setForm)
        this.dialogTlSet=true;
      },
      openPaySource(){
        this.dialogPaySource=true;
      },
      deleteItem(index, list) {
        if(this.index>0){
          this.index=this.index-1;
        }
        list.splice(index, 1);
      },
      addItem() {
        let item = {
          project_name:'',
          constract_amount:'',
          approval_amount: '',
          approved_amount: '',
          deduction_amount:'',
          increase_amount:'',
          rate:'',
          isEgdit:true,
        }
        this.list.push(item)
      },
      goBack() {
        this.$router.push({
          path:'/merchantList',
          query:{
            pageNum: this.$route.query.pageNum
          }
        })
      },
      handleChangeAddress(){     // 更改时调用
        let _this=this;
        const checkedNode =  this.$refs["cascaderAddr"].getCheckedNodes();
        _this.addForm.province_id=checkedNode[0].path[0];
        _this.addForm.city_id=checkedNode[0].path[1];
        _this.addForm.district_id=checkedNode[0].path[2];
        // console.log('2222',checkedNode[0].path)
        // console.log( checkedNode[0].data.label ) ;  //获取当前点击节点的label值
        // console.log( checkedNode[0].pathLabels) ;  //获取由label组成的数组
      },
      getDicList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          code:"CCT",
        }
        this.$axios.dicTable(param).then(res=>{
          if(res.code == 200){
            this.dicList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getPaySourceParamsList(){
        let _this=this;
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          member_id:_this.addForm.id
        }
        this.$axios.findPaySourceParamsMoreList(param).then(res=>{
          if(res.code == 200){
            this.merchantPaySourceParamsList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })

      },
      getPaySourceList(){
        let _this=this;
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          member_id:_this.addForm.id
        }
        this.$axios.getPaySourceList(param).then(res=>{
          if(res.code == 200){
            this.paySourceList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getGradeList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          code:"shopGrade",
        }
        this.$axios.dicListByPid(param).then(res=>{
          if(res.code == 200){
            this.gradeList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getShopList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),

        }
        this.$axios.shopList(param).then(res=>{
          if(res.code == 200){
            this.shopList =res.data;
            this.addForm.shop_id=res.data[0].id;
            this.DataList();
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },

      submitForm(){
        this.$refs.formForRef.validate((valid) => {
          if (valid) {
            let params=this.addForm;
            console.log('params------',params)
            this.$axios.shopSave(params).then(res=>{
              if(res.code == 200){
                this.$message.success("保存成功");
                this.$router.push('/shopList')
              }
            }).catch(error=>{
              this.$message.error("保存错误");
              console.log(error);
            })

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      getOne(){
        let _this=this;
        let param={
          access_token: _this.addForm.access_token,
          company_id: _this.addForm.company_id,
          id:_this.addForm.id
        };
        this.$axios.posMemberOne(param).then((res)=>{
          if(res.code==200){
            let item=res.data;
            _this.addForm.psparams=item.psparams;
            _this.addForm.merchant_name=item.merchant_name;
            _this.addForm.member_id=item.id;
            _this.addForm.grade_id=item.grade_id?item.grade_id:'';
            _this.addForm.shop_id= item.shop_id;
            _this.addForm.artiperson=item.artiperson;
            _this.addForm.pay_sn=item.pay_sn;
            _this.pay_sn=item.pay_sn;
            _this.addForm.province_id=item.province_id;
            _this.addForm.city_id=item.city_id;
            _this.addForm.district_id=item.district_id;
            _this.areaList=[item.province_id,item.city_id,item.district_id];


            _this.addForm.description= item.description;
            _this.addForm.shop_img= item.shop_img;

            _this.addForm.cont_name=item.cont_name;
            _this.addForm.telephone=item.telephone;
            _this.addForm.address=item.address;

            _this.addForm.contract_sn=item.contract_sn;
            _this.addForm.contract_start_time=item.contract_start_time?moment(item.contract_start_time*1000).format('yyyy-MM-DD'):'';

            _this.addForm.contract_end_time=item.contract_end_time?moment(item.contract_end_time*1000).format('yyyy-MM-DD'):'';
            _this.addForm.basic_name=item.basic_name;


            if(_this.addForm.shop_img!=''&&_this.addForm.shop_img!=null){
              var img={
                name:_this.addForm.name,
                url:_this.addForm.shop_img
              }
              _this.fileList.push(img);
            }

          }
          console.log(res);
        });
      },
      uploadFile (item) {
        let _this=this;
        let file = item.raw;
        this.logoFile=item.raw;
        // formData.append('file', file);
        let param={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id')
        };
        this.$axios.getAliJsonCmp(param).then(res=>{
          let data = res['data'];
          console.log('aliyun',data);
          let suffix = _this.get_suffix(file.name);
          let autoname = _this.Ymdhis();
          let key = data['dir'];
          let host = data['host'];
          let path=data['path']!=null&&data['path']!=undefined?data['path']:'';
          let request = new FormData();
          request.append('name', file.name);
          request.append("key", key +path + autoname + suffix);//文件名字，可设置路径
          request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
          request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
          request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
          request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
          request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
          request.append('file', file);//需要上传的文件 file
          console.log('aliyun5555',request);

          axios.post(host,request,{headers:{'Content-Type':'multipart/form-data'}}).then(res => {
            //请求成功，触发then中的函数
            console.log('upload -res--------',res)
            var fileurl = res.data.filename; //上传完成后的文件oss地址
            var fullurl=host+'/'+fileurl;

            _this.addForm.shop_img=fullurl;
            var img={
              name:_this.addForm.name,
              url:_this.addForm.shop_img
            }
            _this.fileList.push(img);
          })
            .catch(error =>
              //请求失败，触发catch中的函数 可省略
              console.log(error)
            )
        });

      },
      resetForm(formName){
        this.$refs[formName].resetFields();
      },
      handleBeforeUpload() {
        console.log('aaaaa');
      },
      uploadSuccess(){

      },
      handleIsopenSelect(){

      },

      getCateMenus(){
        let _this = this;
        let url= '/api/api/mall.Ad_read_lz/getAdPositionMenus';
        let params={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
        };
        axios.post(url,params).then((res)=>{
          if(res.data.code == 200) {
            _this.cateMenus=res.data.data;
          }
        });
        _this.submit=false;
      },
      uploadImg(file, insertFn){
        let _this=this;
        let param={
          access_token: sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
        };
        // console.log(file);
        this.$axios.getAliJsonCmp(param).then(res=>{
          console.log('ali_json------',res)

          let data=res['data'];
          console.log(data);
          let suffix = _this.get_suffix(file.name);
          let autoname = _this.Ymdhis();
          let key = data['dir'];
          let  host = data['host'];

          // let fParam=
          //  {
          //    name:file.name,
          //    key:key +'mrh/'+ autoname + suffix,
          //    policy:data['policy'],
          //    OSSAccessKeyId:data['accessid'],
          //    success_action_status:'200',
          //    callback:data['callback'],
          //    Signature:data['signature'],
          //    file:file
          //  };
          //
          //  qs.stringify(fParam)
          //{headers:{'Content-Type':'application/x-www-form-urlencoded;charset=utf-8'}}
          let path=data['path']!=null&&data['path']!=undefined?data['path']:'';
          let request = new FormData();
          request.append('name', file.name);
          request.append("key", key +path+ autoname + suffix);//文件名字，可设置路径
          request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
          request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
          request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
          request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
          request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
          request.append('file', file);//需要上传的文件 file
          console.log('file=------',file)
          axios.post(host,request,{headers:{'Content-Type':'multipart/form-data'}}).then(res => {
            //请求成功，触发then中的函数
            console.log('upload -res--------',res)
            var fileurl = res.data.filename; //上传完成后的文件oss地址
            var fullurl=host+'/'+fileurl;
            setTimeout(function(){
              insertFn(fullurl); //插入地址
            },2000);


          })
            .catch(error =>
              //请求失败，触发catch中的函数 可省略
              console.log(error)
            )
          // $.ajax({
          //   url: host,
          //   data: request,
          //   processData: false,//默认true，设置为 false，不需要进行序列化处理
          //   cache: false,//设置为false将不会从浏览器缓存中加载请求信息
          //   async: false,//发送同步请求
          //   contentType: false,//避免服务器不能正常解析文件---------具体的可以查下这些参数的含义
          //   // dataType: 'json',//不涉及跨域  写json即可
          //   type: 'post',
          //   success: function (callbackHost, request) { //callbackHost：success,request中就是 回调的一些信息，包括状态码什么的
          //     console.log(callbackHost);
          //     var fileurl = callbackHost.filename; //上传完成后的文件oss地址
          //     var fullurl=host+'/'+fileurl;
          //     var fileObj={
          //       'file_url':fullurl,
          //       'file_path':fileurl
          //     };
          //     console.log(fileObj);
          //     let tempList=vm.picList;
          //     console.log(tempList);
          //     tempList.push(fileObj);
          //    // vm.picList=tempList;
          //
          //     // $('#m-f-up').append("<li><a href='../images/demopic4.jpg'><img src='../images/demopic4.jpg' /></a><i  class='iconfont icon-weikaitong'></i></li>");
          //     //   $('#ad_code').val(fullurl);
          //     // $("#upload_img_icon img").attr('src',fullurl);
          //   },
          //   error: function(XMLHttpRequest, textStatus, errorThrown) {
          //     alert(XMLHttpRequest.status);
          //     alert(XMLHttpRequest.readyState);
          //     alert(textStatus);
          //   }
          // });
        });

        // let imgData = new FormData();
        // imgData.append('file', file);
        // console.log('lu-----------',file)
        // //调用上传图片接口，上传图片  我这里testUpImg是测试接口
        // testUpImg(imgData).then(response => {
        //   if(response.data.code == 0){
        //     //插入后端返回的url
        //     insertFn(response.data.data.url);
        //   }else{
        //   }
        // })
      },
      onCreated(editor) {
        this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      },
      onChange(){
        // this.ruleForm.content=this.editor.txt.html();
      },

      get_suffix(filename) {
        let pos = filename.lastIndexOf('.')
        let suffix = ''
        if (pos != -1) {
          suffix = filename.substring(pos)
        }
        return suffix;
      },
      Ymdhis(){
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth()+1;
        var day = date.getDate();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        return ''+year+month+day+hour+minute+second;
      },
      urlParse(_url = '') {
        let url_obj = new URL(_url || window.location.href);
        let search_path = url_obj.search;
        let handle_path = decodeURIComponent(search_path.substr(1));

        let handle_path_arr = handle_path.split('&');
        let search_params = {};
        for(let item of handle_path_arr) {
          let r = item.split('=');
          search_params[r[0]] = r[1];
        }
        return {
          protpcol: url_obj.protocol,
          search: url_obj.search,
          host: url_obj.host,
          port: url_obj.port,
          pathname: url_obj.pathname,
          searchParams: search_params
        }
      },

    },

    beforeDestroy() {
      const editor = this.editor
      if (editor == null) return
      editor.destroy() // 组件销毁时，及时销毁编辑器
    },

  };
</script>
<style>

  .pay_box-card {
    width: 30% !important;display: inline-block; margin-right: 10px;margin-bottom: 10px;
  }
</style>
